// extracted by mini-css-extract-plugin
var _1 = "ControlBar-module__addOrShareArrow--GozjB";
var _2 = "ControlBar-module__animateUploadProgressBarWidth--XAwzf";
var _3 = "ControlBar-module__animatedBackground--HVtHp";
var _4 = "ControlBar-module__container--LhsbS";
var _5 = "ControlBar-module__footerContainer--E42RE";
var _6 = "ControlBar-module__footerInsightsButtonWrapper--j41rY";
var _7 = "ControlBar-module__left--on68T";
var _8 = "ControlBar-module__right--wpUp9";
export { _1 as "addOrShareArrow", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "footerContainer", _6 as "footerInsightsButtonWrapper", _7 as "left", _8 as "right" }
